import {
	collection,
	doc,
	getDocs,
	getFirestore,
	setDoc,
	updateDoc,
} from "firebase/firestore";
import { useState } from "react";
import { IReport } from "../../types/CommonTypes";
import { toast } from "react-toastify";
import useStorage from "./useStorage";
import { getCurrentDate, sortByDateDesc } from "../constants/helpers";

export default function useServices() {
	const [loading, setLoading] = useState<boolean>(false);
	const [reports, setReports] = useState<any[]>([]);
	const [contacts, setContacts] = useState<any[]>([]);
	const { uploadFile } = useStorage();

	const getReports = async () => {
		const db = getFirestore();
		const websiteCollectionRef = collection(db, "reports");
		const websiteSnapshot = await getDocs(websiteCollectionRef);
		let mapper: any = [];
		websiteSnapshot.docs.map((doc: any) => {
			let data = doc.data();

			return mapper.push({
				id: doc.id,
				...data,
			});
		});
		// Las fechas viven como texto en Firestore, así que el orden
		// (más reciente primero) se resuelve en el cliente.
		setReports(sortByDateDesc(mapper));
	};

	const getContacts = async () => {
		setLoading(true);
		const db = getFirestore();
		const websiteCollectionRef = collection(db, "contacts");
		const websiteSnapshot = await getDocs(websiteCollectionRef);

		let mapper: any = [];
		websiteSnapshot.docs.map((doc: any) => {
			let data = doc.data();
			return mapper.push({
				id: doc.id,
				...data,
			});
		});
		setContacts(sortByDateDesc(mapper));
		setLoading(false);
	};

	const handelSubmitReport = async (report: IReport) => {
		setLoading(true);
		try {
			const db = getFirestore();
			const newId = doc(collection(db, "reports")).id;

			let fileData = null;
			//Cargamos el archivo
			if (report.file) {
				fileData = await uploadFile(report.file, newId, report.name);
			}

			//Creamos el documento
			const docRef = await setDoc(doc(db, "reports", newId), {
				...report,
				date: getCurrentDate(),
				file: fileData,
			});
			console.log("Documento creado con ID:", docRef);
			toast.success("Hemos registrado tu denuncia");
			return newId;
		} catch (error) {
			console.error("Error al crear el documento:", error);
			toast.error("Ha ocurrido un error, intenta nuevamente");
			throw error;
		} finally {
			setLoading(false);
		}
	};

	const updateRow = async (
		id: string,
		collection: string,
		checked: boolean
	) => {
		setLoading(true);
		try {
			const db = getFirestore();
			const docRef = doc(db, collection, id); // obtener referencia al documento
			await updateDoc(docRef, { checked: checked }); // actualizar campo "checked"

			// Reflejamos el cambio en memoria: el checkbox es controlado y sin
			// esto se quedaría pintado con el valor anterior hasta recargar.
			const applyChange = (rows: any[]) =>
				rows.map((row: any) =>
					row.id === id ? { ...row, checked } : row
				);

			if (collection === "contacts") {
				setContacts((current: any) => applyChange(current));
			} else {
				setReports((current: any) => applyChange(current));
			}
		} catch (error) {
			console.log("Error al actualizar el documento:", error);
			toast.error("Ha ocurrido un error, intenta nuevamente");
			throw error;
		} finally {
			setLoading(false);
		}
	};

	return {
		loading,
		reports,
		contacts,
		handelSubmitReport,
		getContacts,
		getReports,
		updateRow,
	};
}
